const createClient = () => ({
  getValueAsync: async (_key, defaultValue) => defaultValue,
  getAllValuesAsync: async () => [],
});

export const createClientWithLazyLoad = createClient;
export const getClient = createClient;
export const disposeAllClients = () => undefined;
export const LogLevel = {};
export const PollingMode = {};
export const DataGovernance = {};
export const createConsoleLogger = () => console;

export default {
  createClientWithLazyLoad,
  getClient,
  disposeAllClients,
};
